import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { DangerSemantic_getInstance3i0xmw7we3iku as DangerSemantic_getInstance } from '../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { body3i5t0n7zprpqb as body } from '../views/theming/Titles.mjs';
import { ClassCastException1atiay3nqgbd as ClassCastException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function renderer(_this__u8e3s4, render) {
  return new (renderer$1())(render);
}
var renderer$1Class;
function renderer$1() {
  if (renderer$1Class === VOID) {
    class $ {
      constructor($render) {
        this.pf9_1 = $render;
      }
      ndg(viewWriter, data, index) {
        var tmp;
        try {
          if (!isInterface(data, Reactive()))
            THROW_CCE();
          tmp = this.pf9_1(viewWriter, data, index);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof ClassCastException()) {
            var _unused_var__etf5q3 = $p;
            // Inline function 'kotlin.with' call
            tmp_0 = viewWriter.jbb(viewWriter.hbb(DangerSemantic_getInstance()), body(viewWriter, 'Error: Could not resolve item type.'));
          } else {
            throw $p;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
    }
    initMetadataForClass($);
    renderer$1Class = $;
  }
  return renderer$1Class;
}
//region block: exports
export {
  renderer as renderer1vumrhd66vl4m,
};
//endregion

//# sourceMappingURL=RecyclerViewRendererSet.ext.mjs.map
